import React from 'react';
import { observer, useAsObservableSource } from 'mobx-react-lite';
import {
    TrashIconWrapper,
    ActiveLabel,
    DatesContainer,
    DateWrapper,
    DateTitle,
    DateValue
} from 'src/main/cms/HomePageCarousel/PromoCarouselList/PromoCarouselListItem.styles';
import { Title, Image } from './SingleHeadline.style';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { SingleHeadlineCarouselState } from './SingleHeadlineCarouselState.state';
import { HeadlineCarouselModelType } from 'src/api/config/headlineCarousel/getHeadlineCarousel';
import { HeadlineCarouselDataState } from 'src/AppState/CmsState/HeadlineCarouselDataState/HeadlineCarouselData.state';
import moment from 'moment';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ListItem, ActionsWrapper, ButtonsWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { MoveUpDown } from 'src/domains/layouts/shared/moreActions/MoveUpDown';

interface PropsType {
    headlineCarouselsData: HeadlineCarouselDataState;
    headlineCarousel: HeadlineCarouselModelType,
}

export const SingleHeadline = observer((propsInner: PropsType) => {
    const props = useAsObservableSource(propsInner);
    const {title, img_url_desktop, img_url_mobile, img_url_tablet, date_from, date_to, is_active } = props.headlineCarousel;
    const [state] = React.useState(() => new SingleHeadlineCarouselState(props));
    const startDate = moment(date_from).format('DD-MM-YYYY hh:mm:ss');
    const endDate = moment(date_to).format('DD-MM-YYYY hh:mm:ss');

    return (
        <ListItem direction='column'>
            <Title data-test='headline-title'>{title}</Title>

            <picture>
                {img_url_desktop ? <source media='(min-width: 968px)' srcSet={img_url_desktop} /> : null}
                {img_url_tablet ?   <source media='(min-width: 615px)' srcSet={img_url_tablet} /> : null}
                {img_url_mobile ?   <Image src={img_url_mobile} alt={title} /> : null}
            </picture>

            <DatesContainer>
                <DateWrapper isStart>
                    <DateTitle>Scheduled start</DateTitle>
                    <DateValue>{startDate}</DateValue>
                </DateWrapper>
                <DateWrapper>
                    <DateTitle>Scheduled finish</DateTitle>
                    <DateValue>{endDate}</DateValue>
                </DateWrapper>
            </DatesContainer>

            <Checkbox labelSide='right' onChange={state.setPublished} isChecked={is_active} isDisabled={false}>
                <ActiveLabel>Published</ActiveLabel>
            </Checkbox>

            <ButtonsWrapper>
                <MoveUpDown moveItemUp={state.moveUp} moveItemDown={state.moveDown}/>
                <ActionsWrapper>
                    <Button version='secondary' size='small' onClick={state.edit}>Edit</Button>
                    <TrashIconWrapper onClick={state.delete} />
                </ActionsWrapper>
            </ButtonsWrapper>
        </ListItem>
    );
});
